import axios from "axios"
import baseURL from "../configs/api"

export const post_comment = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}comment?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_comment = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}comment?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_comment = (primaryKey: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}comment`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: { id: primaryKey, userId: userId }
    }).then(response => response.data);
}

export const getComments = (tenantId: string) => {
    return getFetch("comment", tenantId);
}

export const getComment = (primaryKey: string, tenantId: string) => {
    return getFetch(`comment/${primaryKey}`, tenantId);
}

export const getCommentsReportByAttributeAndAttributeId = (attributeName: string, attributeId: number, tenantId: string) => {
    return getFetch(`comment/GetCommentReportByAttributeNameAndAttributeId?attributeName=${attributeName}&attributeId=${attributeId}`, tenantId);
}

export const getCommentsOfAttribute = (attributeName: string, primaryKey: string, tenantId: string) => {
    return getFetch(`comment?attributeName=${attributeName}&attributeId=${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}